import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../../data/site";
import { Link } from "react-router-dom";

export const ProjectsSection = () => {
  return (
    <section data-testid="projects-section" className="relative bg-[#F8FAFC] py-24 md:py-32 border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="eyebrow mb-4">// Projects · 06</div>
            <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[0.95] max-w-3xl">
              Delivered for the<br /><span className="text-[#0EA5E9]">world's most demanding</span> operators
            </h2>
          </div>
          <Link to="/contact" data-testid="projects-cta" className="group inline-flex items-center gap-3 text-sm uppercase tracking-[0.2em] text-[#475569] hover:text-slate-900">
            Discuss your project <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {PROJECTS.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="bg-[#FFFFFF] group"
              data-testid={`project-card-${i}`}
            >
              <div className="aspect-[4/3] overflow-hidden bg-[#F8FAFC]">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" loading="lazy"/>
              </div>
              <div className="p-6">
                <div className="font-mono-wm text-[10px] tracking-[0.3em] uppercase text-[#0EA5E9] mb-3">
                  CASE / {String(i + 1).padStart(2, "0")} · {p.location}
                </div>
                <h3 className="font-display uppercase text-slate-900 text-xl md:text-2xl tracking-tight leading-tight">{p.title}</h3>
                <p className="text-sm text-[#64748B] mt-1">{p.client}</p>
                <p className="text-sm text-[#475569] mt-4 leading-relaxed">{p.outcome}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
